export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#025574',
    light: '#E5EEF1',
  },
  secondary: {
    main: '#B76243',
    contrastText: '#FFFFFF',
    light: '#D9EDF7',
  },
  text: {
    primary: '#22211F',
    secondary: '#4A5462',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#F2F6F8',
    footer: '#143E4D',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#025574',
    tableSubhead: '#F2F6F8',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#E9EDEF80',
    secondary: '#F8D859',
    light: '#F8FBFE',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    ribbon: '#bbe6fb',
  },
  surface: {
    grey: '#F7F7F7',
    pricing: '#9DAC9D',
  },
  verticalBar: {
    used: '#025574',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
